export function isMessengerImageMime(mime: string | null | undefined): boolean {
  return Boolean(mime && mime.startsWith('image/'));
}
